import { getHandSanitizer } from '../../../../api/eastCoastDataApi/device/HandSanitizerApi'
import CONST from '../../../../utils/const'
import Utils from '../../../../utils/utils'

const state = {
  allHandSanitizer: {},
  HandSanitizerData: {}
}

const getters = {
  getAllHandSanitizer: state => {
    return state.allHandSanitizer
    
  },
}

const actions = {
  async getHandSanitizer({ commit },  condition) {
    const response = await getHandSanitizer(condition);
    await commit('HandSanitizer', response);
  },

}

const mutations = {
  HandSanitizer(state, data) {
    if (Utils.isEmptyObject(data)) {
      return
    }
    state.allHandSanitizer = data
    state.HandSanitizerData = data
  
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}